import React, {useEffect, useState} from 'react'
import vsbl from 'vsbl'
import cx from 'classnames'

import Image from '@/image.js'

import { truncate } from '@/utls.js'

const BrandBlock = ({ brand }) => {
  const [visible, setVisible] = useState(false)
  let vs = null
  const animateBrand = React.createRef()
  useEffect(() => {
    vs = vsbl(animateBrand.current)(() => {
      if (visible) return
      setTimeout(() => {
        setVisible(true)
      }, 400)
    })
    vs.update()
  }, [])
  return (
    <div className={cx('what__brands-single x ac f jcc', {
      'is-visible': visible
    })} ref={animateBrand}>
      <div className='what__brands-image rel x'>
        <div className='what__brands-sticker abs z1 top right'>
          <Image className='' width={200} imageId={brand.mainSticker.imageId} alt={brand.mainSticker.title} />
        </div>
        <Image className='x abs y' imageId={brand.imageId} alt={brand.title} />
        <div className='abs bottom what__brands-block z2 x'>
          <div className='what__brands-text shadow__box bcw p1 x m1 bottom'>
            <span className='s18'>{brand.title}</span>
            <span className='s16 mt1 mb05 what__brands-hidden'>
              {truncate(brand.description, 18, '...')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

class WhatIs extends React.Component {
  constructor () {
    super()
    this.slideshow = React.createRef()
  }
  componentDidMount () {
    const Flickity = require('flickity')
    const slideshow = this.slideshow.current
    const flky = new Flickity(slideshow, {
      contain: true,
      pageDots: false,
      bgLazyLoad: 2,
      prevNextButtons: false
    })

    setTimeout(() => {
      flky.resize()
    }, 100)
  }
  render () {
    const {
      brands,
      title,
      subTitle,
      description
    } = this.props.content
    return (
      <div className='pmy pt1 what'>
        <div className='p15 container--xl ma'>
          <div className='f fw what__wrap jcb ais'>
            <div className='x'>
              <div className=''>
                <h5 className='caps medium mb05 pb05'>{subTitle}</h5>
                <h2 className='mt0 pt0 h1 h1-100'>{title}</h2>
              </div>
            </div>
            <div className='x what__description'>
              <p className='s22'>{description}</p>
            </div>
          </div>
        </div>
        <div className='x what__brands-slideshow'>
          <div className='x' ref={this.slideshow}>
            {brands.map(brand => (
              <BrandBlock brand={brand} key={brand._rev} />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default WhatIs
